if (!customElements.get('show-more-button')) {
  customElements.define(
    'show-more-button',
    class ShowMoreButton extends HTMLElement {
      constructor() {
        super();
        const button = this.querySelector('button');
        button.addEventListener('click', (event) => {
          this.expandShowMore(event);
          const nextElementToFocus = event.target.closest('.parent-display').querySelector('.show-more-item');
          if (nextElementToFocus && !nextElementToFocus.classList.contains('hidden') && nextElementToFocus.querySelector('input')) {
            nextElementToFocus.querySelector('input').focus();
          }
        });
      }
      expandShowMore(event) {
        const parentDisplay = event.target.closest('[id^="Show-More-"]').closest('.parent-display');
        const parentWrap = parentDisplay.querySelector('.parent-wrap');
        this.querySelectorAll('.label-text').forEach((element) => element.classList.toggle('hidden'));
        parentDisplay.querySelectorAll('.show-more-item').forEach((item) => item.classList.toggle('hidden'));
        if (!this.querySelector('.label-show-less')) {
          this.classList.add('hidden');
        }
      }
    }
  );
}
document.addEventListener("DOMContentLoaded", function () {
  const hero = document.querySelector(".collection-hero");
  const desc = document.querySelector(".collection-hero__description");

  if (!hero || !desc) return;

  const button = document.createElement("span");
  button.className = "collection-read-more";
  button.innerText = "Read more";

  desc.after(button);

  button.addEventListener("click", function () {
    hero.classList.toggle("is-expanded");

    if (hero.classList.contains("is-expanded")) {
      button.innerText = "Read less";
    } else {
      button.innerText = "Read more";
    }
  });
});